import { urls } from "../../shared/seo/links";

export function questionsUrl(lang) {
  return urls.sectionPath("questions", lang);
}

// /<questions>/<title-slug>/<id>. A question has one URL, in the language it
// was asked in; `lang` is only the fallback for questions without one.
export function questionUrl(question, lang) {
  return urls.questionPath(question, urls.questionLang(question, lang));
}

// Questions are written by visitors: always show them as plain text.
export function questionExcerpt(text, length = 180) {
  const clean = (text || "").replace(/\s+/g, " ").trim();
  return clean.length > length ? clean.slice(0, length).trim() + "…" : clean;
}

export function currentUser() {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    return null;
  }
}

// Visitors ask questions from their dashboard, so send them to log in first.
// "?ask=1" opens the dashboard on the question form; without it the dashboard
// reopens whichever tab was used last (often "become a lawyer").
export const ASK_PARAM = "ask";

export function askQuestionUrl() {
  const user = currentUser();
  return user && user.role !== "lawyer" ? `/User-Dashboard/?${ASK_PARAM}=1` : "/login";
}
